module.exports = "/_next/static/images/img-hero-galaxy-021a998bd1bc8ba6b2bdbc6bfca2de20.svg";